// extracted by mini-css-extract-plugin
module.exports = {"root":"WithBorder_root__3aCs6","bottom":"WithBorder_bottom__1GKJ_","top":"WithBorder_top__1su_F","left":"WithBorder_left__b05-v","right":"WithBorder_right__xmmZy"};